// Staff roster and invitations (FR-ADM-2). The invitation itself runs in the
// invite-staff Edge Function, which verifies the caller is an owner.
import type { AbstractPowerSyncDatabase } from '@powersync/web';
import { getSupabase } from '@/lib/supabase';
import { nowIso } from '@/lib/db/db';
import type { Role } from '@/app/state';

export interface StaffRow {
  id: string; user_id: string; display_name: string; display_name_my: string | null; status: string;
  public_key: string | null; roles: string | null; has_key: number;
}

export async function listStaff(db: AbstractPowerSyncDatabase, clinicId: string): Promise<StaffRow[]> {
  return db.getAll<StaffRow>(
    `select m.id, m.user_id, m.display_name, m.display_name_my, m.status, m.public_key,
            (select group_concat(r.role) from clinic_member_roles r where r.member_id = m.id) as roles,
            (select count(*) from clinic_key_grants g where g.clinic_id = m.clinic_id and g.grantee_user_id = m.user_id and g.grantee_pubkey = m.public_key and g.revoked_at is null) as has_key
     from clinic_members m where m.clinic_id = ? order by m.display_name`, [clinicId]);
}

export async function inviteStaff(input: { clinicId: string; email: string; displayName: string; displayNameMy?: string | null; roles: Role[] }): Promise<void> {
  const sb = getSupabase();
  const { data, error } = await sb.functions.invoke('invite-staff', {
    body: { clinic_id: input.clinicId, email: input.email.trim(), display_name: input.displayName.trim(), display_name_my: input.displayNameMy ?? null, roles: input.roles },
  });
  if (error) {
    const detail = (data as { error?: string } | null)?.error;   // the function's own message, when it sent one
    throw new Error(detail ?? error.message);
  }
  const res = data as { ok?: boolean; error?: string };
  if (!res?.ok) throw new Error(res?.error ?? 'invitation failed');
}

export async function setMemberStatus(db: AbstractPowerSyncDatabase, memberId: string, status: 'active' | 'inactive', userId: string | null): Promise<void> {
  await db.execute('update clinic_members set status = ?, updated_at = ?, updated_by = ? where id = ?', [status, nowIso(), userId, memberId]);
}
